import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { PAVisualizzaStatoFattureComponent } from './pa-visualizza-stato-fatture';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.pa-visualizza-stato-fatture', {
            url: '/pa-visualizza-stato-fatture',
            params: {
                'numeroFattura': ''
            },
            ncyBreadcrumb: {
                label: 'Fatture Trasmesse',
                parent: 'home.fatturazione-pa'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Fatture Trasmesse PA'
            },
            'views': {
                'homeContent': {
                    template: '<pa-visualizza-stato-fatture flex="100"></pa-visualizza-stato-fatture>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const PAVisualizzaStatoFattureModule: string = ng
    .module('pa-visualizza-stato-fatture', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('paVisualizzaStatoFatture', PAVisualizzaStatoFattureComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/pa-visualizza-stato-fatture/pa-visualizza-stato-fatture.module.ts